module.exports = __webpack_public_path__ + "media/images/rank/regular-lg-13e9ea87d53e170653cbd9a5911e0c0b.svg";